import React from 'react';

interface GridCols {
  lg?: number;
  sm?: number;
}

interface GridProps {
  children: React.ReactNode;
  className?: string;
  cols?: GridCols;
}

const smColClasses: Record<number, string> = {1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3'};
const lgColClasses: Record<number, string> = {1: 'lg:grid-cols-1', 2: 'lg:grid-cols-2', 3: 'lg:grid-cols-3'};

export const Grid: React.FC<GridProps> = ({children, className = '', cols = {sm: 1, lg: 2}}) => {
  const smCols = cols?.sm ?? 1;
  const lgCols = cols?.lg ?? 2;
  const gridClass = `grid min-h-screen ${smColClasses[smCols] ?? 'grid-cols-1'} ${lgColClasses[lgCols] ?? 'lg:grid-cols-2'}`;
  return <div className={`${gridClass} ${className}`.trim()}>{children}</div>;
};
